import settings from '@/settings'

const login = (headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/login/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const detalharFrentista = (id, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/detalhesfrentista/?id=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const AutenticarPin = (headers, data) => {
  return fetch(`${settings.apetrusApi}/frentistas/autenticarpin/${data.id}/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const listaFrentistas = (data, headers) => {
  let url = `${settings.apetrusApi}/frentistas/getbyfrentista/?programa_incentivo=True`
  if (data.empresa) url += `&empresa=${data.empresa}`
  else url += `&posto=${data.posto}`
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const inserirFrentista = (frentista, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(frentista),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarPin = (cnpj, pin, id, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/atualizarpin/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      cnpj: cnpj,
      pin: pin
    }),
    cache: 'default',
    headers: headers
  })
}

// cadastra no programa de incentivo ou realiza solicitação de retirada
const programaIncentivo = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/programaincentivo/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const solicitarRetirada = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/programaincentivo/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const detalhesfrentista = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/detalhesfrentista/?id=${data.id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const getSolicitacoes = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/solicitacoes/?cnpj=${data.cnpj}&id_frentista=${data.id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const confirmarMatricula = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/confirmargerente/?email=${data.email}&matricula=${data.matricula}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

// Premite a troca do pin do frentista
// data = { pin, id_frentista, cnpj }
const redefinirPin = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/redefinirpin/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const editar = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/editar/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

export default {
  detalharFrentista,
  AutenticarPin,
  login,
  listaFrentistas,
  inserirFrentista,
  cadastrarPin,
  programaIncentivo,
  solicitarRetirada,
  detalhesfrentista,
  getSolicitacoes,
  confirmarMatricula,
  redefinirPin,
  editar
}
